{
    "coordinates": [
        44.44782737595892,
        103.93033135961969
    ],
    "tooltip": "Djadochta",
    "title": "Djadocta Formation",
    "country": "Mongolia",
    "period": "Cretaceous",
    "alt": "TODO"
}
